import { Component } from "@angular/core";

@Component({
  selector: "app-aul-008-24",
  standalone: true,
  imports: [],
  templateUrl: "./aul-008-24.component.html",
  styleUrl: "./aul-008-24.component.scss",
})
export class Aul00824Component {}
